import React from 'react';

// What happens over time, left to right: a dot for each moment on a line, its title in bold and a short text under
// it. events are { title, text, isHighlighted }; the moment that matters most is highlighted with a red dot. On a
// phone the moments stack.
export default function Timeline({ events = [] }) {
  return (
    <div className='timeline'>
      {events.map((event) => (
        <div
          key={event.title}
          className={event.isHighlighted ? 'timeline-event highlighted' : 'timeline-event'}
        >
          <span className='timeline-dot' />
          <b className='timeline-title'>{event.title}</b>
          <span className='timeline-text'>{event.text}</span>
        </div>
      ))}
    </div>
  );
}
